import { render } from "./WorksheetItem.vue?vue&type=template&id=72486b7f&scoped=true&ts=true"
import script from "./WorksheetItem.vue?vue&type=script&lang=ts"
export * from "./WorksheetItem.vue?vue&type=script&lang=ts"

import "./WorksheetItem.vue?vue&type=style&index=0&id=72486b7f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72486b7f"]])

export default __exports__